import React, {useEffect, useMemo, useRef} from 'react';
// AG-GRID
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS
import { firebase } from '../firebase/firebaseConfig';

export const InvoiceDetailPage = (props) => {
    const { invoice_prefix, invoice_number } = props.match.params;
    const [data, setData] = React.useState([]);
    const formatValueDollar = (params) => {
        const value = params?.value;
        
        if (typeof value === 'number') {
            return value.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }
    
        return '';
    };
    
    const formatValuePercent = (params) => {
        return params?.value ? `${params?.value}%` : 0;
    }
    const columnDefs = useMemo(() => [
        { field: 'bar_code', width: 150, headerName:"Codigo de barras" },
        { field: 'product_name', width: 300, headerName:"Producto" },
        { field: 'qty', width: 80, headerName:"Cantidad" },
      
        { 
          field: 'product_discount_percent',
          headerName:'Desc(%)',
          width:30,
          valueFormatter: formatValuePercent
        },
        { 
          field: 'product_discount',
          headerName:'Desc($)',
          width:30,
          valueFormatter: formatValueDollar
        },
        { 
          field: 'calculated_cost',
          headerName:'Precio recalc(A/I)',
          width:110,
          valueFormatter: formatValueDollar
        },
        { 
          field: 'calculated_cost_iva',
          headerName:'Costo neto(D/I)',
          width:110,
          valueFormatter: formatValueDollar
        },
        { 
          field: 'suggest_price',
          headerName:'Publico s/comision',
          width:110,
          valueFormatter: formatValueDollar
        },
        { 
          field: 'suggest_price_credit_card',
          headerName:'Publico c/comision',
          width:110,
          valueFormatter: formatValueDollar
        },
        { 
          field: 'suggest_price2',
          headerName:'Publico s/comision (95)',
          width:110,
          valueFormatter: formatValueDollar
        },
        { 
          field: 'suggest_price_credit_card2',
          headerName:'Publico c/comision (95)',
          width:110,
          valueFormatter: formatValueDollar
        },
        { 
          field: 'suggest_price3',
          headerName:'Publico s/comision (80)',
          width:110,
          valueFormatter: formatValueDollar
        },
        { 
          field: 'suggest_price_credit_card3',
          headerName:'Publico c/comision (80)',
          width:110,
          valueFormatter: formatValueDollar
        },
        { 
          field: 'suggest_price4',
          headerName:'Publico s/comision (60)',
          width:110,
          valueFormatter: formatValueDollar
        },
        { 
          field: 'suggest_price_credit_card4',
          headerName:'Publico c/comision (60)',
          width:110,
          valueFormatter: formatValueDollar
        },
       
        
      ], []);
    const getData = async(token) => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/lasir/invoice_detail?type=json`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,

            },
            body: JSON.stringify({
                prefix_invoice: invoice_prefix, 
              invoice_number
          })
        });

        const data = await response.json();
        setData(data)
    }
    useEffect(async()=> {
        const currentUser = await firebase.auth().currentUser;
        const t = await currentUser.getIdToken();
        if (t) {
          getData(t);
        }

    },[])
    // AG GRID
    const gridApiRef = useRef(null);
    useEffect(() => {
        const allData = [];
        if (gridApiRef.current) {
          gridApiRef.current.api.forEachNode((node) => {
            allData.push(node.data);
          });
        }
        return allData;
      },[]);

      const defaultColDef = useMemo(() => ({
        sortable: true, 
        minWidth: 100,
        menuTabs:['filterMenuTab'],
        suppressMenu: true,
        // suppressMenuHide: true,
        unSortIcon: false,
        floatingFilter: true,
        filter: true,
        resizable: true,
    
      }), []);
    return (<>
        <h5>Factura {invoice_prefix}{invoice_number}</h5>
        <hr />
        <div id="myGrid" style={{ height: '500px', width: '100%'}} className="ag-theme-alpine">
        <AgGridReact
          onGridReady={(params) => (gridApiRef.current = params)}
          defaultColDef={defaultColDef}
          pagination={true}
          paginationPageSize={200}
          stopEditingWhenCellsLoseFocus={true}
          rowData={data}
          columnDefs={columnDefs}
        />
      </div>
    </>);
};